module.exports = __webpack_public_path__ + "img/미스틱.72afb479.png";